import React from "react";
import { motion } from "framer-motion";
import { WHY_CHOOSE } from "@/data/content";

export default function WhyChooseUs() {
  return (
    <section id="why" className="relative overflow-hidden bg-navy py-24 md:py-32 grain" data-testid="why-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="max-w-3xl">
          <p className="text-[11px] uppercase tracking-[0.3em] text-gold font-semibold">Why Choose Us</p>
          <h2 className="mt-5 font-serif text-4xl leading-tight text-white sm:text-5xl md:text-6xl">
            One company.<br />One point of contact.<br /><span className="italic text-gold">Complete peace of mind.</span>
          </h2>
          <p className="mt-8 max-w-2xl text-lg leading-relaxed text-white/70">
            From professional housekeeping to complete holiday-let management, we take care
            of the details that keep your property running smoothly and your guests happy.
            With our own professional in-house cleaning service, we deliver a consistent
            standard of cleaning and presentation across your entire property.
          </p>
        </div>

        <div className="mt-20 divide-y divide-white/10 border-t border-white/10">
          {WHY_CHOOSE.map((item, i) => (
            <motion.div
              key={item.n}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
              className="group grid grid-cols-1 items-baseline gap-4 py-10 md:grid-cols-12 md:gap-8"
              data-testid={`why-item-${item.n}`}
            >
              <div className="md:col-span-2">
                <span className="font-serif text-6xl text-white/10 transition-colors duration-500 group-hover:text-gold/60 md:text-7xl">
                  {item.n}
                </span>
              </div>
              <h3 className="font-serif text-2xl text-white md:col-span-4 md:text-3xl">{item.title}</h3>
              <p className="text-base leading-relaxed text-white/55 md:col-span-6">{item.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
